import React from "react";
import { withRouter } from "react-router-dom";
import Checkout from "~/components/checkout";

const CheckoutPage = () => {
	return <Checkout />;
};

export default withRouter(CheckoutPage);
